import { Files } from '../../lib/constants/files'
import { Guide } from '../../lib/types/models/guide/guide'
import { GuideInput } from '../../lib/types/models/guide/guide-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function createGuide(data: GuideInput) {
  if (data.pdf) {
    const file = await uploadFile(Files.GUIDE_PDF, data.pdf)
    if (!file) throw new Error('File not uploaded')
    data.pdf = file
  }

  if (data.picto) {
    const file = await uploadFile(Files.GUIDE_PICTO, data.picto)
    if (!file) throw new Error('File not uploaded')
    data.picto = file
  }

  return restApiClient.url(constructApiUrl(API.guides.create.url, null)).post<Guide>(data)
}
